<template>
	<section id="ceo" class="pt-4 pt-md-5 pb-lg-5">
		<b-container class="pb-4 pb-md-6">
			<b-row class="align-items-center pb-2">
				<b-col cols="12" sm="8" lg="5" xl="4" class="mx-auto ml-lg-0 mr-lg-auto text-center text-left-lg pb-5 pb-lg-0">
					<img src="../assets/img/ceo.jpg" width="500" height="640" alt="Johan Augustsson - Lidl Sverigechef" class="img-fluid d-none d-lg-inline-block">
					<img src="../assets/img/ceo_mob.jpg" width="500" height="340" alt="Johan Augustsson - Lidl Sverigechef" class="img-fluid d-inline-block d-lg-none">
				</b-col>
				<b-col cols="12" sm="10" md="11" lg="7" xl="5" class="mx-auto text-center px-5 px-md-4 px-xl-2">
					<h2 class="text-primary-dark text-uppercase font-weight-bold m-0 pt-sm-3 pt-md-0 pb-3 pb-md-0 pb-lg-3 px-md-2 px-lg-0 px-xl-4">Tillsammans utmanar vi branschen</h2>
					<hr class="border-secondary bold w-5 d-inline-block"/>
					<p class="text-primary-dark px-lg-3 px-xl-0">Vårt uppdrag är att erbjuda högsta kvalitet till bästa pris. Genom att jobba smart och effektivt visar vi att hållbarhet inte måste vara kostsamt. Lidl gör det enkelt för kunderna att göra riktigt bra val.</p>
					<p class="text-primary-dark m-0 pt-2">Johan Augustsson</p>
					<p class="small text-primary-dark text-uppercase">Sverigechef Lidl</p>
					<p class="pt-2 pt-lg-4 pt-xl-5 pb-5 m-0">
						<b-btn 	variant="secondary"
								:href="$creo.browserPdfLink(pdfLink.org, pdfLink.fallback, pdfLink.page)"
								target="_blank"
								class="text-uppercase font-weight-bold">
							Läs mer
						</b-btn>
					</p>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12" sm="6" lg="4" class="pr-3 text-center">
					<hr class="border-primary-trans mt-0"/>
					<scroll-view :offset="200">
						<template slot-scope="visibility">
							<c-number 	key="fignumber1"
										:visible="visibility.fignumber1"
										:title="'Medarbetare'"
										:titleClass="'title pt-2 text-uppercase text-primary-dark font-weight-bold'"
										:startVal="0"
										:endVal="4228"
										:numberClass="'d-inline-block bigger text-primary'"
										:duration="2"
										:separator="' '"/>
						</template>
					</scroll-view>
				</b-col>
				<b-col cols="12" sm="6" lg="4" class="px-3 text-center">
					<hr class="border-primary-trans mt-0"/>
					<scroll-view :offset="200">
						<template slot-scope="visibility">
							<c-number 	key="fignumber2"
										:visible="visibility.fignumber2"
										:title="'Butiker'"
										:titleClass="'title pt-2 text-uppercase text-primary-dark font-weight-bold'"
										:startVal="0"
										:endVal="181"
										:numberClass="'d-inline-block bigger text-primary'"
										:duration="2"
										:separator="' '"/>
						</template>
					</scroll-view>
				</b-col>
				<b-col cols="12" sm="6" lg="4" class="pl-3 text-center">
					<hr class="border-primary-trans mt-0"/>
					<scroll-view :offset="200">
						<template slot-scope="visibility">
							<c-number 	key="fignumber3"
										:visible="visibility.fignumber3"
										:title="'Omsättning, MSEK'"
										:titleClass="'title pt-2 text-uppercase text-primary-dark font-weight-bold'"
										:startVal="0"
										:endVal="10798"
										:numberClass="'d-inline-block bigger text-primary'"
										:duration="2"
										:separator="' '"/>
						</template>
					</scroll-view>
				</b-col>
				<b-col cols="12" sm="6" lg="4" class="pr-3 text-center">
					<hr class="border-primary-trans mt-0"/>
					<scroll-view :offset="200">
						<template slot-scope="visibility">
							<c-number 	key="fignumber4"
										:visible="visibility.fignumber4"
										:title="'Varor i sortimentet'"
										:titleClass="'title pt-2 text-uppercase text-primary-dark font-weight-bold'"
										:startVal="0"
										:endVal="2224"
										:numberClass="'d-inline-block bigger text-primary'"
										:duration="2"
										:separator="' '"/>
						</template>
					</scroll-view>
					<hr class="border-primary-trans mt-0 d-none d-lg-block"/>
				</b-col>
				<b-col cols="12" sm="6" lg="4" class="px-3 text-center">
					<hr class="border-primary-trans mt-0"/>
					<scroll-view :offset="200">
						<template slot-scope="visibility">
							<c-number 	key="fignumber5"
										:visible="visibility.fignumber5"
										:title="'Från leverantörer i Sverige'"
										:titleClass="'title pt-2 text-uppercase text-primary-dark font-weight-bold'"
										:startVal="0"
										:endVal="31"
										:numberClass="'d-inline-block bigger text-primary'"
										:post="'%'"
										:postClass="'d-inline-block bigger text-primary'"
										:duration="2"
										:separator="' '"/>
						</template>
					</scroll-view>
					<hr class="border-primary-trans mt-0 d-none d-sm-block"/>
				</b-col>
				<b-col cols="12" sm="6" lg="4" class="pl-3 text-center">
					<hr class="border-primary-trans mt-0"/>
					<scroll-view :offset="200">
						<template slot-scope="visibility">
							<c-number 	key="fignumber6"
										:visible="visibility.fignumber6"
										:title="'Miljömärkt/Eko'"
										:titleClass="'title pt-2 text-uppercase text-primary-dark font-weight-bold'"
										:startVal="0"
										:endVal="12"
										:numberClass="'d-inline-block bigger text-primary'"
										:post="'%'"
										:postClass="'d-inline-block bigger text-primary'"
										:duration="2"
										:separator="' '"/>
						</template>
					</scroll-view>
					<hr class="border-primary-trans mt-0"/>
				</b-col>
			</b-row>
		</b-container>
	</section>
</template>
<script>
	import CNumber from '../components/Number.vue';
	export default {
		name: 'Ceo',
		props: {
			pdfLink: {
				default: null
			}
		},
		components: {
			CNumber
		}
	}
</script>
